import Link from '../../Components/Link/Link';
export default Link;
